import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RightOutlined } from '@ant-design/icons';
import { VertContainer, VertBreadcrumb, VertIcon } from '@vertem-core/vertice-ds';
import ShowcasePopBallon from "components/PopBallon/ShowcasePopBallon/ShowcasePopBallon";
import CollapsePopBallon from "components/PopBallon/CollapsePopBallon/CollapsePopBallon";
import { TermsPage } from "components/PopBallon/temsPage";
import { hasAccepted } from "redux/Reducers/PopBallon/VertemGiftApi";
import useActiveCampaign from 'Hooks/useVertemGift';
import { useNavigate } from "react-router";
import CustomBannerSupplier from "components/BannerSupplier/CustomBannerSupplier";
import ynToBool from "Utils/ynToBool";


const PageContent = () => {
    const breadcrumb = [
        { title: 'Início', path: '/' },
        { title: 'Campanhas', path: '/campanhas' },
    ];

    return (
        <VertContainer>
            <VertContainer
                spacingX="regular"
                spacingY="small"
            >
                <VertBreadcrumb hasBackButton={true}
                    separator={<VertIcon component={RightOutlined} />}
                    items={breadcrumb}
                />
            </VertContainer>
            <CustomBannerSupplier />

            <ShowcasePopBallon />

            <CollapsePopBallon />


        </ VertContainer>

    )
}

const PopBallonPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isCallingActiveVertemGift, isCampaignActive } = useActiveCampaign();
    const { hasAcceptedTerm } = useSelector(state => state.VertemGift);



    const isHideTerms = !ynToBool(process.env.REACT_APP_HIDE_MODAL_TERMS_POP_BALLON) ? hasAcceptedTerm : true;


    useEffect(() => {
        if (!ynToBool(process.env.REACT_APP_HAS_VERTEM_GIFT)) {
            navigate('/');
        } else {
            dispatch(hasAccepted());
        }
    }, [dispatch, isCampaignActive, navigate]);

    return (
        <>{isCampaignActive && (isHideTerms ? <PageContent /> : <TermsPage />)}</>
    );
}

export default PopBallonPage;